import React from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    }
})

class SamplePrint extends React.Component {

    constructor(props){
      super(props)
    }
    
   
  
   render(props) {
    const record= this.props.record
    const classes = this.props.classes
    //var ucns =  record && record.cu_numbers? (record.cu_numbers).split(';').map(cun=>(`${cun }`)): ''
    var ucns =  record && record.cu_numbers? (record.cu_numbers).split(';'): [];
    //var ssns =  record && record.cu_numbers? (record.cu_numbers).split(';').map(cun=>(`${cun.split(',')[1] + ','}`)): ''
    const title = (record && record.test_mode=== 'VMT')? 'PLASMA UNIT SAMPLE SUBMISSION': 
                  (record && record.test_mode=== 'ATYA')? 'ATYA TESTING PACKING LIST':
                  (record && record.test_mode=== 'SPE')? 'SPE/STS PACKING LIST/WORKSHEET':
                  (record && record.test_mode=== 'NAT')? 'NAT SAMPLE SUBMISSION': '';
    return(
        <div className={classes.root}>
            <div className={classes.title}>
                <h2>{title}</h2>
                <p className={classes.p}>Printed on {moment(Date()).format('MM/DD/yyyy')}</p>
            </div>

            <div className={classes.body}> 
            {record.test_mode !=='NAT'&& <span><b>Unit Control Numbers: </b>{ucns.length > 0 && ucns.map((ucn,index)=>(<div>{ucn}{index < (ucns.length-1) && ';'}</div>),<br/>)} </span>}
            {record.test_mode ==='NAT'&& 
            <div>
                 <span><b>Begining Unit Control Numbers: </b>{record ? record.s_ucn: ''} </span>
                 <br /><br />
                 <span><b>Ending Unit Control Numbers: </b>{record ? record.e_ucn: ''} </span>
            </div>
            }
            <br /><br />
                 <span><b>Total: </b>{record ? record.total: ''} </span>
            <br /><br />
            <span><b>Time Removed from Storage for Shipment: </b> {record ? `${record.time_removed}` : ''} </span>
            <br /><br />
            <span><b>Initial: </b> {record ? `${record.init }`   : ''} </span>
            <br /><br />
            <span><b>Date: </b>  {record ?`${moment(record.init_date).format('MM/DD/yyyy')}` : '' } </span>
            <br /><br />
            <span><b>Location: </b> {record ? `${record.location }`   : ''} </span>
            </div>
            
        </div>
    )
  }
}

export default SamplePrint